const calculateTokenExpiration = (expiresIn: number, bufferSeconds = 60) => {
  // Subtract buffer time to refresh before actual expiration
  const expirationTime = Date.now() + (expiresIn - bufferSeconds) * 1000;

  // Optional: Add debug logging only in development
  if (process.env.NODE_ENV === 'development') {
    console.debug('Token expiration calculated:', {
      expiresIn: `${expiresIn}s`,
      bufferSeconds: `${bufferSeconds}s`,
      effectiveExpiry: `${expiresIn - bufferSeconds}s`,
      expiresAt: new Date(expirationTime).toISOString(),
    });
  }

  return expirationTime;
};

export { calculateTokenExpiration };
